import React from "react";
import ReactDOM from "react-dom";
import WeHaveMovedPage from "./pages/we-have-moved/WeHaveMovedPage";

function normaliseToBaseUrl() {
    const { pathname, search, hash } = window.location;
    if (pathname !== "/" || search || hash) {
        window.history.replaceState(null, "", "/");
    }
}

normaliseToBaseUrl();
window.addEventListener("popstate", normaliseToBaseUrl);

ReactDOM.render(
    <React.StrictMode>
        <WeHaveMovedPage />
    </React.StrictMode>,
    document.getElementById("root")
);
